import React from "react";
import PropTypes from "prop-types";

import { StyledH1 } from "./ComponentTitleStyle";

import { useTranslation } from "react-i18next";

const ComponentTitle = ({ value, maxWidth, textAlign }) => {
  const { t } = useTranslation();
  return (
    <StyledH1 textAlign={textAlign} maxWidth={maxWidth}>
      {t(value)}
    </StyledH1>
  );
};

ComponentTitle.propTypes = {
  value: PropTypes.string,
  maxWidth: PropTypes.string,
};
export default ComponentTitle;
